// extracted by mini-css-extract-plugin
export default {"wrap":"MailDelivery-module--wrap--eaBA4","mailDelivery":"MailDelivery-module--mailDelivery---vr9w","warn":"MailDelivery-module--warn--IOUAq","tip":"MailDelivery-module--tip--yYDKD"};